
import {Component } from 'preact';

interface SwitchProps {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    name?: string;
    optionLabels?: string[];
    disabled?: boolean;
    text?: string;
    isSmall?: boolean;
}

/**
 * @private
 */
export default class Switch extends Component<SwitchProps> {
    handleKeyPress(e: KeyboardEvent) {
        if (e.keyCode === 32 || e.code === '32') {
            const {checked, onChange} = this.props;
            e.preventDefault();
            onChange(!checked);
        }
    }

    render() {
        const {
            id, text, checked, onChange, name, optionLabels, isSmall, disabled
        } = this.props;
        return (
            <div className={isSmall ? 'switch--small' : 'switch'}>
                <div className="switch__container">
                    <input
                        type="checkbox"
                        name={name}
                        className="switch__checkbox"
                        id={id}
                        checked={checked}
                        onChange={(e) => onChange((e.target as HTMLInputElement).checked)}
                        disabled={disabled}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    />
                    <label
                        role="switch"
                        aria-checked={checked}
                        className="switch__label"
                        htmlFor={id}
                        tabIndex={disabled ? -1 : 1}
                        onKeyDown={this.handleKeyPress}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <span
                            className="switch__inner"
                            data-yes={optionLabels[0]}
                            data-no={optionLabels[1]}
                            tabIndex={-1}
                        />
                        <span className="switch__controller" tabIndex={-1} />
                    </label>
                </div>
                <span className='switch__text'>{text}</span>
            </div>
        );
    }
}

// Set optionLabels for rendering.
Switch.defaultProps = {
    optionLabels: ['', ''],
    name: null,
    disabled: false,
    text: '',
    isSmall: false,
};
